import 'jquery-viewport-checker';
import 'gsap/dist/ScrollTrigger.min.js';

$W.on('load' ,function() {
	$('.js-background-scale').addClass('zoom-in')
});

$W.on('load scroll', function () {
	let scrolled = $(this).scrollTop();
	$('.js-banner-foil').css('transform', 'translate3d(0, ' + -(scrolled * 0.25) + 'px, 0)'); // parallax (25% scroll rate)
});


$(function(){


  const controller = new ScrollMagic.Controller();

  // request animation frame on scroll
  let scheduledAnimationFrame;
  function readAndUpdatePage(){
    scheduledAnimationFrame = false;
  }

  function onScroll () {
    if (scheduledAnimationFrame){
      return;
    }

    scheduledAnimationFrame = true;
    requestAnimationFrame(readAndUpdatePage);
  }

  window.addEventListener('scroll', onScroll);

  $('.js-anim-image').each(function() {
    let itemSequence = new TimelineMax({paused: true});
    let itemSequenceHover = new TimelineMax({paused: true});
    let childContainer = $(this).find('.js-anim-image__inner');
    let childImg = $(this).find('.js-anim-image__inner img');

    itemSequence
      .fromTo(childContainer, 0.8,{transformOrigin: 'center center', scale: 1.3}, {scale: 1, ease: Power1.easeInOut})
      .fromTo(childImg, 0.8,{transformOrigin: 'center center', scale: 1.3}, {scale: 1, ease: Power1.easeInOut},'-=0.5')

    itemSequenceHover
      .to(childContainer, 0.5, {scale: 0.9, ease: Power1.easeInOut})
      .to(childImg, 0.5, {scale: 1.25, ease: Power1.easeInOut},'-=0.5');

    let scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.7,
    })
      .addTo(controller);

    scene.on('enter', function () {
      itemSequence.play();
    });

  });



  function anim() {
    if($('.js-anim').length > 0){
      $('.js-anim').viewportChecker({offset: 20});
    }
  }

  anim();



//animation text color 

if ( $('.js-text-container').length) {
  const paragraphe = $('.js-text-container__text');
  let mySplitText = new SplitText(paragraphe, { type: "words,chars, lines" });
  gsap.set(paragraphe, { perspective: 0 });
  let tl = gsap.timeline({
      scrollTrigger: {
          trigger: ".js-text-container",
          pin: false,
          start: "-=450",
          end: "+=550",
          scrub: 0,
      }
  })
      .from(mySplitText.chars, { duration: 2, opacity: 0.3, ease: "back", stagger: 0.5 });
}

})
